module.exports = __webpack_public_path__ + "static/portfolio-91217379786a167b4c8d5a3abeef2181.png";